import { render } from "./tarkpay-redirect.vue?vue&type=template&id=f4952e96&scoped=true&ts=true"
import script from "./tarkpay-redirect.vue?vue&type=script&lang=ts"
export * from "./tarkpay-redirect.vue?vue&type=script&lang=ts"

import "./tarkpay-redirect.vue?vue&type=style&index=0&id=f4952e96&lang=scss&scoped=true"

import exportComponent from "/opt/TeamCity/buildAgent/work/f19c936fb20a8ac2/vue-embed/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4952e96"]])

export default __exports__